import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-comment-too-long-modal',
  templateUrl: './comment-too-long-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentTooLongModalComponent {
  protected cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  public dialogRef: MatDialogRef<CommentTooLongModalComponent> = inject(MatDialogRef);
  public data: number = inject(MAT_DIALOG_DATA);

  cancel() {
    this.dialogRef.close();
  }
}
